import { Flex, Input } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { FormField } from '../../../components/FormField'
import { FormModal } from '../../../components/FormModal'
import { useAppToast } from '../../../helpers'
import { SectorService } from '../../../services/Sector/SectorService'

interface IProps {
  isOpen: boolean
  onClose: () => void
}

interface IForm {
  name: string
}

const defaultForm: IForm = {
  name: ''
}

export function SectorCreateModal({ isOpen, onClose }: IProps) {
  const toast = useAppToast()
  const sectorService = new SectorService()
  const [form, setForm] = useState<IForm>(defaultForm)
  const [errors, setErrors] = useState<{ [key: string]: string[] }>({})

  const handleSave = async (event: React.FormEvent) => {
    event.preventDefault()

    if (!formValid()) {
      return
    }

    sectorService
      .create(form)
      .then(() => {
        toast.success('Setor criado com sucesso')

        onClose()
      })
      .catch((error) => {
        setErrors(error.response.data.errors)
      })
  }

  const formValid = () => {
    return form.name
  }

  useEffect(() => {
    setForm(defaultForm)
  }, [isOpen])

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Criar setor"
      onSubmit={handleSave}
      size="compact"
      isConfirmDisabled={!formValid()}
    >
      <Flex direction="column">
        <FormField label="Nome" error={errors.name} isRequired>
          <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        </FormField>
      </Flex>
    </FormModal>
  )
}
